import React, { Component } from 'react';
import {Grid, Segment, Table, Header, Dropdown, Loader} from 'semantic-ui-react';
import _ from 'lodash';

const preparePersonSelection = (user) => {
    const { uuid, name, records } = user;
    const personOptions = [];
    for (let i = 0; i < records.length; i++) {
        personOptions.push({ text: records[i].name, value: records[i].uuid });
    }
    return personOptions;
}

const prepareCompanySelection = (user) => {
    const { companies } = user;
    const companiesOptions = [];
    for (let i = 0; i < companies.length; i++) {
        companiesOptions.push({ text: companies[i].companyName, value: companies[i].companyId });
    }
    return companiesOptions;
}

class ProfileBioPlans extends Component {
    state = {
        selectedPerson: this.props.user.uuid,
        selectedCompany: this.props.user.companies[0].companyId || null,
    }
    componentDidMount() {
        // this.getSelectedPersonBenefitPlan(this.state.selectedPerson);
        this.getSelectedPersonBenefitConfig(this.state.selectedPerson);
        console.log('this.props.benefits', this.props.benefits);
    }
    // getSelectedPersonBenefitPlan = (userId) => {
    //     if (userId) {
    //         this.setState({selectedPerson: userId});
    //     }
    //     const selectedPersonId = userId || this.state.selectedPerson;
    //     const selectedPersonBenefitPlans = this.props.benefitPlans[selectedPersonId];
    //     if (!selectedPersonBenefitPlans) {
    //         this.props.getUserBenefitPlan({accessToken: this.props.user.accessToken, userId: selectedPersonId});
    //     }
    // }
    getSelectedPersonBenefitConfig = (uuid) => {
        this.setState({selectedPerson: uuid});
        this.props.getUserBenefitConfig({accessToken: this.props.user.accessToken, userId: uuid, companyId: this.state.selectedCompany});
    }

    getSelectedCompanyBenefitConfig = (companyId) => {
        this.setState({selectedCompany: companyId});
        this.props.getUserPlanConfigBenefit({accessToken: this.props.user.accessToken, companyId: companyId});
    }

    render() {
        const personOptions = preparePersonSelection(this.props.user);
        const companiesOptions = prepareCompanySelection(this.props.user);
        
        const selectedPersonBenefitPlans = this.props.benefitPlans[this.state.selectedPerson];
        if (!selectedPersonBenefitPlans) {
            return <Loader active />;
        }
        const {
            startDate,
            endDate,
            benefitplans
        } = selectedPersonBenefitPlans;

        const selectedPersonBenefitConfig= this.props.benefits[this.state.selectedPerson];
        if (!selectedPersonBenefitConfig) {
            return <Loader active />;
        }

        const allBenefits = JSON.parse(selectedPersonBenefitConfig.allBenefits)
        console.log('allBenefits', allBenefits);
        console.log('allBenefits.headerTitle', allBenefits.headerTitle);

        return (
            <Grid.Column width={16}>
                <Header as='h4' attached='top' block>
                    My Plan
                </Header>
                {
                    /*
                        <Segment attached>
                            <Dropdown
                                placeholder='Select Person'
                                fluid
                                selection
                                options={personOptions}
                                value={this.state.selectedPerson}
                                onChange={(e, { value}) => this.getSelectedPersonBenefitConfig(value)}
                            />
                        </Segment>
                    */
                }
                {this.props.user.companies.length > 1 &&
                <Segment attached>
                    <Dropdown
                        placeholder='Select Company'
                        fluid
                        selection
                        options={companiesOptions}
                        value={this.state.selectedCompany}
                        onChange={(e, { value}) => this.getSelectedCompanyBenefitConfig(value)}
                    />
                </Segment>}
                <Segment attached>
                    <Segment textAlign='center'>{ allBenefits.headerTitle }</Segment>
                    <Table celled>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Coverage Name</Table.HeaderCell>
                                <Table.HeaderCell>Details</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {
                                _.map(allBenefits.sections, (section) => {
                                    const { buttonTitle, contents } = section;
                                    return (
                                        <Table.Row key={ buttonTitle }>
                                            <Table.Cell>
                                                { buttonTitle }
                                            </Table.Cell>
                                            <Table.Cell>
                                                <Table fixed>
                                                    <Table.Body>
                                                        {
                                                            _.map(contents, (content, index) => {
                                                                if (index !== 0) {
                                                                    if (content.type === 'header') {
                                                                        return (
                                                                            <Table.Row active key={ index }>
                                                                                <Table.Cell colSpan='2'>{ content.value } </Table.Cell>
                                                                            </Table.Row>
                                                                        )
                                                                    }

                                                                    if (content.type === 'single') {
                                                                        return (
                                                                            <Table.Row key={ index} >
                                                                                <Table.Cell>{ content.leftValue }</Table.Cell>
                                                                                <Table.Cell>{ content.rightValue }</Table.Cell>
                                                                            </Table.Row>
                                                                        )
                                                                    }

                                                                    {
                                                                        /*


                                                                        if (content.type === 'multiple') {
                                                                            return (
                                                                                <Table.Row>
                                                                                    <Table.Cell>{ content.leftValue }</Table.Cell>
                                                                                    <Table.Cell>{ content.rightValue }</Table.Cell>
                                                                                </Table.Row>
                                                                            )
                                                                        }
                                                                        */
                                                                    }


                                                                }

                                                            })
                                                        }
                                                    </Table.Body>
                                                </Table>
                                            </Table.Cell>
                                        </Table.Row>
                                    );
                                })
                            }
                        </Table.Body>
                    </Table>
                    <Segment textAlign='center'>{ allBenefits.footerTitle }</Segment>
                </Segment>
            </Grid.Column>
        );
    }
}

export default ProfileBioPlans;
